// @core/api/endpoints/tenant/create_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTenantRequest,
  TenantResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Create a new tenant
 * Creates a new tenant organization within the platform. The caller becomes the owner of the newly created tenant and can manage its settings and members.
 */
export async function CreateTenant(
  data: CreateTenantRequest,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.post<TenantResponse>(requestPath, data, requestOptions);
}
